import React from 'react';
import { PageHeader } from '@components/Shared/PageHeader';
import { EditDocumentsContainer } from '@containers/EditDocumentsContainer';
import { PageContainer } from './EditDocuments.styles';

export default function EditDocuments() {
  return (
    <PageContainer>
      <PageHeader 
        title="Edit Documents" 
        description="View and modify legal documents"
      />
      <EditDocumentsContainer />
    </PageContainer>
  );
}